import { render, staticRenderFns } from "./NavigationMaster.vue?vue&type=template&id=4a1c0504&scoped=true"
import script from "./NavigationMaster.vue?vue&type=script&lang=js"
export * from "./NavigationMaster.vue?vue&type=script&lang=js"
import style0 from "./NavigationMaster.vue?vue&type=style&index=0&id=4a1c0504&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1c0504",
  null
  
)

export default component.exports